import type { UseFormReturn } from "react-hook-form";
import { CheckoutForm, CheckoutPayload } from "@/checkout/types";
import {
  isEqualAddresses,
  SUBSCRIPTION_CONTRACT_META_KEY,
} from "@cappelendamm/e-commerce-services";

export const fillFormFromCheckoutPayload = (
  form: UseFormReturn<CheckoutForm>,
  payload: CheckoutPayload,
) => {
  const { setValue } = form;
  const { customer, freight, meta, product, paymentMethod } = payload;
  const { addresses, email, phone, birthDate } = customer;
  const { delivery, billing } = addresses;
  const [birthYear, birthMonth, birthDay] = birthDate.split("-");

  if (email) {
    setValue("email", email);
  }
  setValue("phone", phone);
  setValue("birth.day", birthDay ?? "");
  setValue("birth.month", birthMonth ?? "");
  setValue("birth.year", birthYear ?? "");
  setValue("subscription", product);
  setValue("payment.type", paymentMethod.identifier);
  setValue("delivery" as keyof CheckoutForm, delivery);
  setValue("billing" as keyof CheckoutForm, billing);

  setValue(
    "billingAddressIsSameAsDeliveryAddress",
    isEqualAddresses(delivery, billing),
  );

  const childBirthDate = meta[SUBSCRIPTION_CONTRACT_META_KEY.CHILD_BIRTH_DATE];

  if (childBirthDate) {
    const [childBirthYear, childBirthMonth, childBirthDay] =
      childBirthDate.split("-");
    setValue(
      `meta.${SUBSCRIPTION_CONTRACT_META_KEY.CHILD_BIRTH_DATE}.day` as const,
      childBirthDay ?? "",
    );
    setValue(
      `meta.${SUBSCRIPTION_CONTRACT_META_KEY.CHILD_BIRTH_DATE}.month` as const,
      childBirthMonth ?? "",
    );
    setValue(
      `meta.${SUBSCRIPTION_CONTRACT_META_KEY.CHILD_BIRTH_DATE}.year` as const,
      childBirthYear ?? "",
    );
  }

  if (freight) {
    const subscriptionFreight = form.getValues("freight");
    if (subscriptionFreight) {
      const initialFreightWithSelected = subscriptionFreight.initial.map(
        (freightOption) => ({
          ...freightOption,
          selected: freight.initialSku === freightOption.sku,
        }),
      );
      const recurringFreightWithSelected = subscriptionFreight.recurring.map(
        (freightOption) => ({
          ...freightOption,
          selected: freight.recurringSku === freightOption.sku,
        }),
      );
      setValue("freight.initial", initialFreightWithSelected);
      setValue("freight.recurring", recurringFreightWithSelected);
    }
  }
};
